export default "__VITE_ASSET__Bj03rosb__"